const fr: Record<string, string> = {
  'guitarChords.list.search': 'Recherche',
  'guitarChords.list.searchPlaceholder': 'Rechercher par nom…',
  'guitarChords.list.root': 'Fondamentale',
  'guitarChords.list.fretFilter': 'Frette par corde',
  'guitarChords.list.anyFret': '-',
  'guitarChords.list.add': 'Ajouter un accord',
  'guitarChords.list.loadError': "Impossible de charger l'inventaire des accords.",
  'guitarChords.list.deleteTitle': "Supprimer l'accord",
  'guitarChords.list.deleteMessage': 'Retirer « {{name}} » de l\'inventaire ?',
  'guitarChords.form.name': 'Nom',
  'guitarChords.form.suggestName': 'Utiliser le nom suggéré : {{name}}',
  'guitarChords.form.rootNote': 'Fondamentale',
  'guitarChords.form.description': 'Description',
  'guitarChords.form.addTitle': 'Ajouter un accord',
  'guitarChords.form.editTitle': "Modifier l'accord",
  'guitarChords.difficulty.label': 'Difficulté',
  'guitarChords.difficulty.level0': 'Facile',
  'guitarChords.difficulty.level1': 'Simple',
  'guitarChords.difficulty.level2': 'Modéré',
  'guitarChords.difficulty.level3': 'Intermédiaire',
  'guitarChords.difficulty.level4': 'Difficile',
  'guitarChords.difficulty.level5': 'Très difficile',
};

export default fr;
